module.exports = __webpack_public_path__ + "img/ic_48_faq_down.bc6972b0.svg";